import { FuseNavigationItem } from '@fuse/components/navigation';

// ===== menus_frontend

export const compactNavigation: FuseNavigationItem[] = [];
export const defaultNavigation: FuseNavigationItem[] = compactNavigation;
export const futuristicNavigation: FuseNavigationItem[] = compactNavigation;
export const horizontalNavigation: FuseNavigationItem[] = compactNavigation;
